/**
 * True when the error is an aborted request, either at the top level or nested under
 * `networkError`. Apollo aborts in-flight queries on refetch, variable changes and unmount,
 * so these are expected and not worth reporting.
 */
const isAbortError = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') return false;

    if ((error as { name?: unknown }).name === 'AbortError') return true;

    const networkError = (error as { networkError?: unknown }).networkError;

    if (!networkError || typeof networkError !== 'object') return false;

    return (networkError as { name?: unknown }).name === 'AbortError';
};

export { isAbortError };
